import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from '~/components/core';
import { useAppSelector, useStyles } from '~/hooks';
import { appSettingsSelector } from '~/state/selectors';
import { scaleSize } from '~/constants/scale';
import { Theme } from '~/theme';
import { TraderAccountReturnData } from '~/api-services/AuthDataService/types';
import { AntDesign } from "~/components/core/Icons";
import { FONT_SIZE_XS } from '~/constants';

type Props = {
    traderAccount: TraderAccountReturnData;
    selectedAccountId: number;
};

export default function TraderAccountRow({ traderAccount, selectedAccountId }: Props) {
    console.log(traderAccount);
    const styles = useStyles(stylesGenerator);
    const { colorScheme } = useAppSelector(appSettingsSelector);
    return (
        <>
            <View
                style={[
                    styles.positionGroupContainer,
                    styles.positionGroupClose,
                    colorScheme === 'dark' ? styles.borderColorDark : styles.borderColorWhite,
                ]}
                key={'traderAccountContainer' + traderAccount.accountId}
            >
                <View style={styles.columnContainer}>
                    <Text style={styles.text}>{'account-id'}</Text>
                    <Text style={styles.text}>{traderAccount.accountId.toString()}</Text>
                </View>
                <View style={styles.columnContainer}>
                    <Text style={styles.text}>{'currency'}</Text>
                    <Text style={styles.text}>{traderAccount.currency}</Text>
                </View>
                <View style={styles.columnContainer}>
                    <Text style={styles.text}>{'account-balance-title'}</Text>
                    <Text style={styles.text}>{traderAccount.balance.toString()}</Text>
                </View>
                <View style={styles.columnContainer}>
                    <Text style={styles.text}>{traderAccount.enabled ? 'Enabled' : 'Disabled'}</Text>
                </View>
                <View style={styles.columnContainer}>
                    {selectedAccountId === traderAccount.accountId ?
                        <AntDesign name="checkcircle" size={scaleSize(18)} style={styles.iconColor} />
                        : null}
                </View>
            </View>
        </>
    );
}

const stylesGenerator = (theme: Theme) =>
    StyleSheet.create({
        text: {fontSize: FONT_SIZE_XS},
        iconColor: { color: theme.tabIconSelected },
        columnContainer: { flexWrap: 'wrap', marginHorizontal: 'auto', paddingLeft: '1%', justifyContent: 'center' },
        positionGroupContainer: {
            flexDirection: 'row',
            borderWidth: 1,
            width: '100%',
            borderTopLeftRadius: scaleSize(5),
            borderTopRightRadius: scaleSize(5),
            height: scaleSize(50),
            backgroundColor: theme.backgroundSecondary,
        },
        positionGroupClose: { borderRadius: scaleSize(5), marginTop: scaleSize(7) },
        borderColorDark: { borderColor: theme.background },
        borderColorWhite: { borderColor: theme.border_2 },


    });
